import { ClientAdProductType } from '@zg-rentals/ts-customer-analytics-client';

export const PackageTypes = new Set<ClientAdProductType>([
  ClientAdProductType.BASE_PACKAGE,
  ClientAdProductType.ENHANCED_PACKAGE,
  ClientAdProductType.PREMIUM_PACKAGE,
  ClientAdProductType.PREMIUM_PLUS_PACKAGE,
  ClientAdProductType.SIGNATURE_PACKAGE,
]);
